import { createNamedOptionChoice, fetchNamedOptionChoices } from "features/settings/api/namedOptionResource";
import { clearanceResource } from "features/settings/constants/healthSelectionResources";

export const fetchClearances = async (search: string) => {
  return fetchNamedOptionChoices(clearanceResource, search);
};

export const createClearance = async (name: string) => {
  return createNamedOptionChoice(clearanceResource, name);
};
